import React from 'react';

export const StatCard = ({ title, value, subtitle, icon: Icon, trend, className = '' }) => {
  return (
    <div className={`luxury-card p-6 ${className}`} data-testid={`stat-${title.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-start justify-between mb-4">
        <p className="text-xs uppercase tracking-wider text-muted-foreground">{title}</p>
        {Icon && <Icon size={18} className="text-gold" />}
      </div>
      <p className="font-serif text-3xl text-white mb-1">{value}</p>
      {subtitle && (
        <p className={`text-sm ${trend === 'up' ? 'text-emerald-400' : trend === 'down' ? 'text-red-400' : 'text-muted-foreground'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};
